import { render, staticRenderFns } from "./DemoSimpleTableDense.vue?vue&type=template&id=12e176f9"
import script from "./DemoSimpleTableDense.vue?vue&type=script&lang=js"
export * from "./DemoSimpleTableDense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports